import { create } from "zustand";

export const useStoreCRMSearch = create((set, get) => ({
  crmBulkSearchPayload: [],
  crmBulkSearchData: [],
  isCRMBulkSearchLoading: true,
  isCRMBulkSearchFetched: false,

  // Set payload
  setCRMBulkSearchPayload: (data) => {
    set({
      crmBulkSearchPayload: data,
      isCRMBulkSearchLoading: data.length > 0,
      isCRMBulkSearchFetched: false,
      // crmBulkSearchData: [], // optional: reset data on new payload
    });
  },

  // Set entire data manually
  setCRMBulkSearchData: (data) => {
    set({
      crmBulkSearchData: data,
      isCRMBulkSearchLoading: data.length < get().crmBulkSearchPayload.length,
      isCRMBulkSearchFetched: data.length === get().crmBulkSearchPayload.length,
    });
  },

  // Add or update a chunk

  addChunkInCRMBulkSearchData: (chunk) => {
    const state = get();
    const existing = [...state.crmBulkSearchData];

    // Determine the ID key and value
    let idKey = "recordId";
    if (chunk.person_id) {
      idKey = "person_id";
    }
    if (chunk.contact_id) {
      idKey = "contact_id";
    }
    if (chunk.organization_id) {
      idKey = "organization_id";
    }

    const idValue = chunk[idKey];

    console.log("chunk", chunk);

    // Find the index using any of the 3 ID types
    const index = existing.findIndex(
      (r) =>
        r.person_id === idValue ||
        r.contact_id === idValue ||
        r.recordId === idValue ||
        r.organization_id === idValue
    );

    const newEntry = {
      [idKey]: idValue,
      records: [...chunk.data],
    };

    if (index !== -1) {
      existing[index] = {
        ...existing[index],
        ...newEntry,
      };
    } else {
      existing.push(newEntry);
    }

    const isLoading = existing.length < state.crmBulkSearchPayload.length;
    const isFetched = existing.length === state.crmBulkSearchPayload.length;

    set({
      crmBulkSearchData: existing,
      isCRMBulkSearchLoading: isLoading,
      isCRMBulkSearchFetched: isFetched,
    });
  },

  // ✅ Get specific record by ID
  getCRMSearchRecordById: (id) => {
    const state = get();
    return state.crmBulkSearchData.find(
      (item) =>
        item.person_id === id || item.contact_id === id || item.recordId === id || item.organization_id === id
    );
  },
  getCRMSearchRecordByIdFlat: (id) => {
    const state = get();
    const matched = state.crmBulkSearchData.find(
      (item) =>
        item.person_id === id || item.contact_id === id || item.recordId === id || item.organization_id === id
    );

    if (!matched || !Array.isArray(matched.records)) return [];

    // Extract and flatten all non-null inner `records` arrays
    return matched.records
      .map((entry) => entry?.records || []) // get inner records array
      .flat(); // flatten into a single array
  },
}));
